import PropTypes from "prop-types";

// MUI components
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
    loadConsumerFiltersState,
    loadProductSecondaryDataState,
    loadWeightToggleState,
    loadInterpolationToggleState,
    loadInterpolationDetailsState,
} from "../../store/features/matchNetSlice";
import { loadProductOrderState, loadProductsVisibility } from "../../store/features/productsInfoSlice";

function Reset({ studyTypeMethod = "", dataMappingData = [], variableMapping = [], setVariableMapping = () => {}, resetStudyProducts = () => {}, handleResetCorrelation = () => {}, setSelectedVariables = () => {} }) {
    //REDUX
    const dispatch = useDispatch();
    // const productSecondaryData = useSelector((state) => state.matchNetStore.productSecondaryData);
    const defaultProductSecondaryData = useSelector((state) => state.matchNetStore.defaultProductSecondaryData);
    const interpolationToggle = useSelector((state) => state.matchNetStore.interpolationToggle);
    const interpolationDetails = useSelector((state) => state.matchNetStore.interpolationDetails);
    const consumerFilters = useSelector((state) => state.matchNetStore.consumerFilters);
    const defaultProductsOrder = useSelector((state) => state.productsInfoStore.defaultProductsOrder);
    const matchNetWeightToggle = useSelector((state) => state.matchNetStore.weightToggle);

    const handleReset = () => {
        // filters
        const resetCf = (consumerFilterStr = {}) => {
            const updatedCf = JSON.parse(consumerFilterStr.replaceAll(":true}", ":false}"));
            return updatedCf;
        };

        const resetAllCf = (consumerFilterStr = {}) => {
            const updatedCf = JSON.parse(consumerFilterStr.replaceAll(":true", ":false"));
            return updatedCf;
        };

        const updatedFilters = {
            ...consumerFilters,
            [studyTypeMethod]: {
                currentSelectedFilters: resetCf(JSON.stringify(consumerFilters[studyTypeMethod].currentSelectedFilters)),
                currentSelectedAllFilters: resetAllCf(JSON.stringify(consumerFilters[studyTypeMethod].currentSelectedAllFilters)),
                missingFilters: {},
                filterSelectionStatus: false,
                isFilterAcrossProducts: false,
            },
        };
        dispatch(loadConsumerFiltersState(updatedFilters));

        // weight Toggle
        const updatedWeightToggle = matchNetWeightToggle.map((item) => (item.studyTypeMethodTitle === studyTypeMethod ? { ...item, weightToggle: true } : item));

        dispatch(loadWeightToggleState(updatedWeightToggle));
        // setWeightToggle((prev) => prev.map((item) => (item.studyTypeMethodTitle === studyTypeMethod ? { ...item, weightToggle: false } : item)));

        // analysis result
        resetStudyProducts(studyTypeMethod);

        // product visibility
        dispatch(loadProductOrderState(defaultProductsOrder));
        dispatch(loadProductsVisibility({}));

        // kpi visibility — scoped to this study only
        const currentStudyData = dataMappingData.find(({ study_type_method_title }) => study_type_method_title === studyTypeMethod);
        const defaultCats = new Set((currentStudyData?.mapping?.default_mapping?.columns ?? []).map(({ macroCategory }) => macroCategory));
        const backendVariables = (currentStudyData?.mapping?.all_mapping?.columns ?? [])
            .filter(({ macroCategory }) => !defaultCats.has(macroCategory))
            .flatMap(({ displayLabels }) => displayLabels.map(({ backendVariable }) => backendVariable));
        setSelectedVariables((prev) => ({
            ...prev,
            [studyTypeMethod]: backendVariables,
        }));

        // varibaleMapping
        const defaultMapping = dataMappingData.find((item) => item.study_type_method_title === studyTypeMethod);
        const updatedVariableMapping = variableMapping.map((item) =>
            item.study_type_method_title === studyTypeMethod
                ? {
                      ...item,
                      mapping: JSON.parse(JSON.stringify(defaultMapping.mapping.default_mapping.columns)),
                  }
                : item
        );
        setVariableMapping(updatedVariableMapping);
        // correlation (reset for this study)
        handleResetCorrelation(studyTypeMethod);

        // interpolation: only reset if interpolation was applied to this specific study
        if (interpolationToggle && interpolationDetails?.studyTypeMethod?.title === studyTypeMethod) {
            dispatch(loadInterpolationToggleState(false));
            dispatch(loadInterpolationDetailsState({}));
            dispatch(loadProductSecondaryDataState([...defaultProductSecondaryData]));
        }
    };

    return (
        <Tooltip
            title="Reset Default Study View"
            placement="top-end"
        >
            <Button
                size="small"
                className="custom-btn liner-light-blue-background me-4 bold-content"
                variant="contained"
                onClick={handleReset}
            >
                Reset
            </Button>
        </Tooltip>
    );
}
Reset.propTypes = {
    studyTypeMethod: PropTypes.string,
    dataMappingData: PropTypes.array,
    variableMapping: PropTypes.array,
    setVariableMapping: PropTypes.func,
    resetStudyProducts: PropTypes.func,
    handleResetCorrelation: PropTypes.func,
    setSelectedVariables: PropTypes.func,
};
export default Reset;
